export const links = [
  {
    link: "https://vnpt.com.vn/",
    image: require("../assets/TĐBCVT.jpg"),
    desc: "Tập đoàn Bưu chính Viễn thông Việt Nam",
  },
  {
    link: "https://www.vinaphone.com.vn/",
    image: require("../assets/vinaphone.png"),
    desc: "VNPT Vinaphone - Nhà mạng nhanh nhất Việt Nam",
  },
  {
    link: "https://vnptmedia.vn/",
    image: require("../assets/media.jpg"),
    desc: "VNPT Media - Tổng công ty Truyền thông",
  },
  {
    link: "https://www.vnpt-technology.vn/vi",
    image: require("../assets/technology.jpg"),
    desc: "VNPT Technology",
  },
];

export const menuItems = [
  {
    title: "Giới thiệu",
    url: "/introduce",
    submenu: [
      {
        title: "Giới thiệu chung",
        url: "gioi-thieu-chung",
      },
      {
        title: "cơ cấu tổ chức",
        url: "co-cau-to-chuc",
      },
      {
        title: "Hạ tầng mạng lưới",
        url: "ha-tang",
      },
    ],
  },
  {
    title: "Trang chủ",
    url: "/",
  },
  {
    title: "Tin tức",
    url: "/tintuc",
    submenu: [
      {
        title: "tin nổi bật",
        url: "tinnoibat",
      },
      {
        title: "tin hoạt động",
        url: "tinhoatdong",
      },
    ],
  },
  {
    title: "Dịch vụ",
    url: "/service",
  },
  {
    title: "Media",
    url: "/media",
    submenu: [
      {
        title: "thư viện hình ảnh",
        url: "thuvienhinhanh",
      },
      {
        title: "thư viện video",
        url: "thuvienvideo",
      },
    ],
  },
  {
    title: "Liên hệ",
    url: "/service",
  },
];
export const slugify = (text) => {
  let resStr = text;
  resStr = resStr
    .toLowerCase()
    .trim()
    .replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
    .replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
    .replace(/ì|í|ị|ỉ|ĩ/g, "i")
    .replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
    .replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
    .replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
    .replace(/đ/g, "d")
    .replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A")
    .replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E")
    .replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I")
    .replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O")
    .replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U")
    .replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y")
    .replace(/Đ/g, "D")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "")
    .replace(/\u02C6|\u0306|\u031B/g, "");

  return resStr;
};
